import {
	Component,
	Inject,
	OnInit,
	ChangeDetectionStrategy
} from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { HttpErrorResponse } from "@angular/common/http";

@Component({
	selector: "core-errordialog",
	styleUrls: ["./style.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	templateUrl: "errordialog.html"
})
export class CoreErrorDialogComponent implements OnInit {
	messages: string[] = [];
	constructor(
		public dialogRef: MatDialogRef<CoreErrorDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: HttpErrorResponse
	) {
		let msg =
			"Your session has expired. Please re-login to renew your session.";
		this.messages.push(msg);
	}

	ngOnInit(): void {}

	enterOk() {
		this.dialogRef.close(true);
	}
}
